import { isEmpty } from 'lodash';
import { CandidateKey } from '~/definitions/candidates';
import { getStore } from '~/mobx/AppStore';

export const validateCandidateForm = (): CandidateKey[] => {
    const { candidateStore } = getStore();
    const { selectedCandidateEdit } = candidateStore;

    let key: CandidateKey[] = [];
    const requiredFields: CandidateKey[] = ['firstName', 'lastName', 'isConsentReceived'];

    // All empty case
    if (!selectedCandidateEdit) {
        key = [...requiredFields];
        candidateStore.setFieldsKeyWithIssues(key);
        return key;
    }

    // Validate required fields: firstname, lastname
    if (isEmpty(selectedCandidateEdit.firstName.trim())) {
        key.push('firstName');
    }

    if (isEmpty(selectedCandidateEdit.lastName.trim())) {
        key.push('lastName');
    }

    // Validate zipcode
    if (!isEmpty(selectedCandidateEdit.postNumber) && !/^\d{4}$/.test(selectedCandidateEdit.postNumber)) {
        key.push('postNumber');
    }

    // Validate ballotNumber
    if (!isEmpty(selectedCandidateEdit.ballotNumber) && !/^[1-9]\d*$/.test(selectedCandidateEdit.ballotNumber)) {
        key.push('ballotNumber');
    }

    // Validate required fields: consent
    if (!selectedCandidateEdit.isConsentReceived) {
        key.push('isConsentReceived');
    }

    candidateStore.setFieldsKeyWithIssues(key);
    return key;
};
